/**
 * Maps the Sent documents filter state to `GET /college-documents/sends` query params.
 * `universityId`, `status` and `q` are omitted (not sent as empty strings) when unset, since the
 * backend treats an absent param differently from an empty-string filter.
 */
export const buildSendsQueryParams = ({ universityId, status, q, page, size }) => ({
  universityId: universityId || undefined,
  status: status || undefined,
  q: q || undefined,
  page,
  size,
});
